import React, { useState } from 'react';
import { B } from '../constants';
import { flights as flightsApi } from '../api';
import FlightSearchForm from './FlightSearchForm';
import FlightResults from './FlightResults';
import Modal from './ui/Modal';

export default function FlightSearchModal({
  onClose,
  onSelectFlight,
  initialOrigin,
  initialDestination,
  initialDepartureDate,
  initialReturnDate,
  selectedOfferId,
}) {
  const [offers, setOffers] = useState(null);
  const [searchId, setSearchId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [fallbackLink, setFallbackLink] = useState(null);

  const handleSearch = async (params) => {
    setLoading(true);
    setError('');
    setOffers(null);
    setFallbackLink(null);
    try {
      const res = await flightsApi.search(params);
      if (res.provider === 'skyscanner_fallback') {
        setFallbackLink(res.bookingLink);
        setError(res.message || 'Search flights on Skyscanner');
      } else {
        setOffers(res.offers || []);
        setSearchId(res.searchId);
      }
    } catch (err) {
      setError(err.message || 'Flight search failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen onClose={onClose} title="✈️ Search flights" size="lg" ariaLabel="Search flights">
      <div style={{ background: B.sand, margin: '-20px -28px', padding: 20, borderRadius: 16 }}>
        <FlightSearchForm
          initialOrigin={initialOrigin}
          initialDestination={initialDestination}
          initialDepartureDate={initialDepartureDate}
          initialReturnDate={initialReturnDate}
          onSearch={handleSearch}
          loading={loading}
          error={fallbackLink ? '' : error}
        />
      </div>

      {fallbackLink && (
        <div style={{ marginTop: 24, textAlign: 'center', padding: 24, background: 'white', borderRadius: 12 }}>
          <p style={{ color: B.muted, marginBottom: 16, fontSize: 14 }}>
            Flight search is not configured. Search directly on Skyscanner.
          </p>
          <a
            href={fallbackLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              background: B.amber,
              color: B.night,
              borderRadius: 10,
              fontSize: 15,
              fontWeight: 700,
              textDecoration: 'none',
            }}
          >
            Search on Skyscanner
          </a>
        </div>
      )}

      {(offers !== null || (loading && !fallbackLink)) && (
        <div style={{ marginTop: 24 }}>
          <FlightResults
            offers={offers}
            loading={loading}
            searchId={searchId}
            onSelect={onSelectFlight}
            selectedOfferId={selectedOfferId}
          />
        </div>
      )}
    </Modal>
  );
}
